import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { EndpointService } from './endpoint.service';
import { BaseResponse } from '../responses/BaseResponse';
import { Observable } from 'rxjs';
import { UserCanOrderResponse } from '../responses/UserCanOrderReponse';
import { PostAutoOrderStatusRequest } from '../../core/requests/PostAutoOrderStatusRequest';

@Injectable({ providedIn: 'root' })
export class OrdersService {
  constructor(private _http: HttpClient) {
  }

  cancelOrderRequest(orderId: number): Observable<BaseResponse> {
    return this._http.post<BaseResponse>(EndpointService.cancelOrderRequest + `?orderId=${orderId}`, {});
  }

  canUserOrder(userId: string, benefitId: number, payWithCard: boolean = false, payWithSalaryAllowed: boolean = false): Observable<UserCanOrderResponse> {
    return this._http.get<UserCanOrderResponse>(EndpointService.userCanOrder + `?userId=${userId}&benefitId=${benefitId}&payWithCard=${payWithCard}&payWithSalaryAllowed=${payWithSalaryAllowed}`);
  }

  updateAutoOrderStatus(filter: PostAutoOrderStatusRequest): Observable<BaseResponse> {
    return this._http.post<BaseResponse>(EndpointService.updateAutoOrderStatus, filter);
  }
}
